import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://public_key@ingest_host/0000000", // Use a dummy DSN that satisfies Sentry's DSN regex validation. The real DSN is injected on the server-side via the `tunnel`.
    // integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    integrations: [Sentry.reportingObserverIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // https://docs.sentry.io/platforms/javascript/troubleshooting/#dealing-with-ad-blockers
    tunnel: "/tracetunnel/",
});
